import { server } from '@/infra/server'

export type CessTokenParam = {
  sessionData: string
  sessionId: string
}

export type CheckEmailOwnershipParams = {
  email: string
  identity: string
  cessToken: CessTokenParam
}

// Sucesso é 204 (sem corpo); 403/404/502/etc. rejeitam a Promise (AxiosError)
const acManagerController = {
  checkEmailOwnership: (params: CheckEmailOwnershipParams) =>
    server.post<void>('check-email-ownership', params),
}

export default acManagerController
